(function (document) {
  const productAccordion = document.querySelector('.product-accordion');
  // If no product accordion found, do nothing.
  if (!productAccordion) return;

  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('swatch-list-update', updateProductAccordion);
  }

  /**
   * Update any relevant details in the product accordion.
   */
  function updateProductAccordion(data) {
    const { detail, feature } = data;
    // If the feature or value are falsy, do nothing.
    if (!feature || !detail) return;
    // Find all elements within the product accordion that match the updated
    // feature.
    const eligibleElements = productAccordion
      .querySelectorAll(`[data-product-accordion-update=${feature}]`);
    eligibleElements.forEach((element) => {
      element.innerHTML = detail;
    });
  }
})(document);
